import { useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";
import Confirm from "./Modals/Confirm";

export default function ProjectManager({ files, project, reload, openMediaModal, toast, setToken}) {
    const [name, setName] = useState(project ? project.ProjectName : "");
    const [desc, setDesc] = useState(project ? project.ProjectDesc : "");
    const [date, setDate] = useState((project && project.Date) ? project.Date.substring(0,10) : "");
    const [enddate, setEnddate] = useState((project && project.EndDate) ? project.EndDate.substring(0,10) : "");

    const [deleting, setDeleting ] = useState(false);

    async function updateProject() {
        await axios.put(( window.API_ENDPOINT || "/api/" )+"projects", {
                "projectID": project.ProjectID,
                "projectName": name,
                "projectDesc": desc,
                "date": date,
                "endDate": enddate || null
            }).then((res)=>{
                toast.success("Succes! AffectedRows: "+res.data.affectedRows);
                reload();
            }).catch((r)=>{
                if (r.status === 403) {
                    toast.error("Session expired. Please log in again.");
                    return setToken(null);
                }
                toast.error("Something went wrong... Please try again.");
                console.log(r);
                reload();
            });
    }

    function deleteProject() {
        setDeleting(false);
        axios.delete(( window.API_ENDPOINT || "/api/" )+"projects/project/"+project.ProjectID)
            .then((res)=>{
                toast.success("Succes! AffectedRows: "+res.data.affectedRows);
                reload();
            }).catch((r)=>{
                if (r.status === 403) {
                    toast.error("Session expired. Please log in again.");
                    return setToken(null);
                }
                toast.error("Something went wrong... Please try again.");
                console.log(r);
                reload();
            });
    }

    if (!project) 
        return (
            <div id="projectManager" className="projectManager">
                <div id="slider" className="slider">
                </div>
                <div id="controls" className="controls">
                    <form action="">
                        <label htmlFor="name">Name:</label>
                        <input type="text" className="controls__input" id="name" name="projectName" disabled/>
                        <br/>
                        <label htmlFor="desc">Description:</label>
                        <textarea type="text" className="controls__textarea" id="desc" name="projectDesc" disabled></textarea>
                        <br/>
                        <label htmlFor="date">Date:</label>
                        <input type="date" name="date" id="date" disabled/>
                        <br/>
                        <label htmlFor="date">End Date:</label>
                        <input type="date" name="enddate" id="enddate" disabled/>
                        <br/><br/>
                        <input className="controls__btn" type="submit" value="Submit"disabled/>
                        <input className="controls__btn" type="button" value="Add Image" disabled/>
                        <input className="controls__btn" type="button" value="Delete" disabled/>
                    </form>
                </div>
            </div>
        );

    const sources = project.Sources ? project.Sources.split(";") : [];
    const types = project.Types ? project.Types.split(";") : [];

    return (
        <div id="projectManager" className="projectManager">
            <div id="slider" className="slider">
                {sources.map((source,idx)=>{
                    switch (types[idx]) {
                        case "1":
                            return <div className="slider__cell" key={"doremifa"+idx} onClick={()=>{openMediaModal(idx)}}>
                                <img className="slider__img" onError={({ currentTarget })=>{currentTarget.onerror=null;currentTarget.src="/assets/notfound.png"}} key={"doremi"+idx} src={"/assets/images/"+source} alt="" />
                            </div>
                        case "2":
                            return <div className="slider__cell" key={"doremifa"+idx} onClick={()=>{openMediaModal(idx)}}>
                                <img className="slider__img" key={"doremi"+idx} src={"https://img.youtube.com/vi/"+source+"/mqdefault.jpg"} alt="" />
                            </div>
                        default:
                            return <></>;
                    }
                })}
            </div>
            <div id="controls" className="controls">
                <label htmlFor="name">Name:</label>
                <input type="text" className="controls__input" id="name" name="projectName" value={name} onChange={e=>setName(e.target.value)} />
                <br/>
                <label htmlFor="desc">Description:</label>
                <textarea type="text" className="controls__textarea" id="desc" name="projectDesc" value={desc} onChange={e=>setDesc(e.target.value)}></textarea>
                <br/>
                <label htmlFor="date">Date:</label>
                <input type="date" name="date" id="date" value={date} onChange={e=>setDate(e.target.value)} />
                <br/>
                <label htmlFor="date">End Date:</label>
                <input type="date" name="enddate" id="enddate" value={enddate} onChange={e=>setEnddate(e.target.value)} />
                <br/><br/>
                <input className="controls__btn" type="button" value="Submit" onClick={updateProject}/>
                <input className="controls__btn" type="button" value="Add Image" onClick={()=>{openMediaModal(-1)}}/>
                <input className="controls__btn" type="button" value="Delete" onClick={()=>setDeleting(true)} />
            </div>
            {deleting &&
                createPortal(
                    <Confirm callback={deleteProject} onCancel={()=>setDeleting(false)}>Are you sure you want to delete project "{project.ProjectName}"?</Confirm>,
                    document.body
                )
            }
        </div>
    )
}